<div
  class="card"
  [ngClass]="{
    'card--interactive': interactive,
    'card--job': variant === 'job',
    'card--ai': ai,
    'card--horizontal': orientation === 'horizontal',
    'card--blue': background === 'blue'
  }">
  <!-- Header slot -->
  <div class="card__header" *ngIf="hasHeader">
    <ng-content select="[slot=header]"></ng-content>
  </div>

  <!-- Content slot (default) -->
  <div class="card__content" [ngClass]="{ 'card__content--horizontal': orientation === 'horizontal' }">
    <ng-content></ng-content>
  </div>

  <!-- Details slot for job cards -->
  <div class="card__details" *ngIf="hasDetails">
    <ng-content select="[slot=details]"></ng-content>
  </div>

  <!-- Time slot for job cards -->
  <div class="card__time" *ngIf="variant === 'job'">
    <ng-content select="[slot=time]"></ng-content>
  </div>

  <!-- Footer slot -->
  <div class="card__footer" *ngIf="hasFooter">
    <ng-content select="[slot=footer]"></ng-content>
  </div>
</div>
